import { render, staticRenderFns } from "./project-switcher.vue?vue&type=template&id=837d75f8&scoped=true&"
import script from "./project-switcher.vue?vue&type=script&lang=js&"
export * from "./project-switcher.vue?vue&type=script&lang=js&"
import style0 from "./project-switcher.vue?vue&type=style&index=0&id=837d75f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837d75f8",
  null
  
)

export default component.exports